<template>
  <article class="page page-profile">
    <section>
      <article class="profile-info">
        <header>
          <h1>My Profile</h1>

          <AppButton
            class="btn-outline btn-secondary"
            @click="showEditModal = true"
          >
            Edit
          </AppButton>
        </header>

        <section>
          <h2>Name</h2>

          <p v-if="authStore.user.firstName || authStore.user.lastName">
            {{ authStore.user?.firstName }} {{ authStore.user?.lastName }}
          </p>

          <p v-else>
            N/A
          </p>
        </section>

        <AppUserAddress
          class="!px-0"
          :data="authStore.user"
        />

        <section class="account-status">
          <h2>Account Status</h2>

          <div>
            <FontAwesomeIcon
              class="text-2xl"
              :class="authStore.user?.isVerified ? 'text-[#12854C]' : 'text-[#CCCCCC]'"
              :icon="faBadgeCheck"
            />

            <span class="text-black font-semibold">
              {{ authStore.user?.isVerified ? 'Verified' : 'Not Verified' }}
            </span>
          </div>

          <template v-if="!authStore.user?.isVerified">
            <p>
              <em>
                *Verifying your account allows you to view protected categories, providing exclusive access to enhanced
                features and content.
              </em>
            </p>

            <AppButton
              class="btn-solid btn-secondary py-2.5 px-6 mt-6 text-sm"
              @click="verificationStep = 1"
            >
              Verify your account now
              <FontAwesomeIcon :icon="faChevronRight" />
            </AppButton>
          </template>
        </section>
      </article>
    </section>

    <!--    modal to update authStore.user?-->
    <Transition name="fade">
      <AppModal
        v-if="showEditModal"
        :disabled="isSubmitting"
        class="profile-edit-modal"
        size="xl"
        @close="showEditModal = false"
      >
        <template #header>
          <h2>Edit Profile Information</h2>

          <p>
            Keep your profile up-to-date by editing your personal information below. Ensure your contact details and
            preferences are current to enhance your experience.
          </p>
        </template>

        <ProfileForm
          v-model:is-submitting="isSubmitting"
          @confirm="showEditModal = false"
        />
      </AppModal>
    </Transition>

    <Transition name="fade">
      <AppModal
        v-if="verificationStep"
        class="profile-verification-modal"
        size="xl"
        :disabled="isSubmitting"
        @close="verificationStep = null"
      >
        <VerificationSubmitNumberForm
          v-if="verificationStep === 1"
          v-model:phone-number="phoneNumber"
          v-model:is-submitting="isSubmitting"
          @confirm="verificationStep = 2"
        />

        <VerificationOtpForm
          v-else-if="verificationStep === 2"
          v-model:is-submitting="isSubmitting"
          :phone-number="phoneNumber"
          @close="verificationStep = null"
        />
      </AppModal>
    </Transition>
  </article>
</template>

<script setup>
import { computed, ref } from 'vue';

import { AppButton, AppModal } from '@/components/app';

import { ProfileForm, VerificationOtpForm, VerificationSubmitNumberForm } from '@/components/forms';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBadgeCheck, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

import { useAuthStore } from '@/store';
import { AppUserAddress } from '@/components/app';

const authStore = useAuthStore();

const verificationStep = ref(0);
const showEditModal = ref(false);

const phoneNumber = ref(null);
const isSubmitting = ref(false);

// const userAddress = computed(() => {
//   const address = ref('');
//
//   const detailsArray = [
//     authStore.user?.streetAddress,
//     authStore.user?.building,
//     authStore.user?.suburb,
//     authStore.user?.city,
//     authStore.user?.province,
//     authStore.user?.postalCode,
//   ];
//
//   detailsArray.forEach((detail) => detail ? address.value = address.value + detail + ', ' : '');
//
//   return address.value !== '' ? address : 'N/A';
// });

const userAddress = computed(() => {
  const line1 = [authStore.user?.streetAddress, authStore.user?.building].filter(Boolean).join(', ').trim();
  const line2 = [authStore.user?.suburb, authStore.user?.city].filter(Boolean).join(' ').trim();
  const line3 = [authStore.user?.province, authStore.user?.postalCode].filter(Boolean).join(' ').trim();

  return [
    line1,
    line2,
    line3,
  ].filter(Boolean);
});
</script>
